import { Box, Flex } from '@rebass/grid'
import * as classnames from 'classnames/bind'
import * as React from 'react'
import Lightbox from 'react-image-lightbox'
import ReactPlayer from 'react-player'
import { connect } from 'react-redux'
import { Text } from 'src/elements'
import { Dispatch, RootState } from 'src/store'
import { getContentType, getPlaybackRate } from 'src/utils'
import styled from 'styled-components'
import materialStyles from './material.scss'

const cx = classnames.bind({ ...materialStyles })

interface IConnectProps {
  material: IMaterial
  onStarted?: () => void
  onPaused?: () => void
  onEnded?: () => void
  isActive?: boolean
}

type IContentProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch> &
  IConnectProps

const AudioContent = ({
  isActive,
  isPlaying,
  material,
  playbackRateIdx,
  onStarted,
  onPaused,
  onEnded,
  onProgressChange
}: IContentProps) => {
  if (!material.downloadUrl && isActive && isPlaying && onEnded) {
    onEnded()
  }
  return material.downloadUrl ? (
    <ReactPlayer
      url={material.downloadUrl}
      controls={true}
      width="100%"
      height={56}
      playing={isActive && isPlaying}
      playbackRate={getPlaybackRate(playbackRateIdx)}
      onPlay={onStarted}
      onPause={isActive && onPaused ? onPaused : undefined}
      onEnded={onEnded}
      onProgress={onProgressChange}
      config={{ file: { attributes: { controlsList: 'nodownload' } } }}
    />
  ) : (
    <Text.LabelGray>無聲音檔案</Text.LabelGray>
  )
}

class ImageContent extends React.Component<IContentProps> {
  public state = {
    showImage: false
  }
  public handleImageOpen = () => {
    this.setState({ showImage: true })
  }
  public handleImageClose = () => {
    this.setState({ showImage: false })
  }
  public render() {
    const { isActive, isPlaying, material, onEnded } = this.props
    const { showImage } = this.state
    // image content just ends directly
    if (isActive && isPlaying && onEnded) {
      onEnded()
    }
    return material.downloadUrl ? (
      <React.Fragment>
        <img
          onClick={this.handleImageOpen}
          src={material.downloadUrl}
          alt={material.name}
        />
        {showImage && (
          <Lightbox
            wrapperClassName={cx('lightbox')}
            mainSrc={material.downloadUrl}
            onCloseRequest={this.handleImageClose}
          />
        )}
      </React.Fragment>
    ) : (
      <Text.LabelGray>無圖片檔案</Text.LabelGray>
    )
  }
}

const TextContent = ({
  isActive,
  isPlaying,
  material,
  onStarted,
  onEnded
}: IContentProps) => {
  // text content just ends directly
  if (isActive && isPlaying && onEnded) {
    onEnded()
  }
  const ImageContainer = styled(Box)`
    border-radius: 4px;
    background-color: #ececec;
    width: 44px;
    height: 44px;
    margin-right: 12px;
    padding: 10px;
  `
  return material.downloadUrl ? (
    <Flex>
      <ImageContainer>
        <a target="_blank" href={material.downloadUrl}>
          <img src={require('./../../images/common/icon/icon-link.svg')} />
        </a>
      </ImageContainer>
      <Flex flexDirection="column">
        <Box>
          <a target="_blank" href={material.downloadUrl}>
            <Text.SubtitleBold>{material.name}</Text.SubtitleBold>
          </a>
        </Box>
        <Box>
          <a target="_blank" href={material.downloadUrl}>
            <Text.LabelGray
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                width: '320px'
              }}
            >
              {material.downloadUrl}
            </Text.LabelGray>
          </a>
        </Box>
      </Flex>
    </Flex>
  ) : (
    <Text.SubtitleBold>{material.name}</Text.SubtitleBold>
  )
}

const Content = (props: IContentProps) => {
  const contentType = getContentType(props.material.metadata)
  switch (contentType) {
    case 'audio':
      return <AudioContent {...props} />
    case 'image':
      return <ImageContent {...props} />
    case 'text':
      return <TextContent {...props} />
    default:
      return <Text.LabelGray>不支援此類型教材</Text.LabelGray>
  }
}

const mapState = ({ lectureContent }: RootState) => ({
  isPlaying: lectureContent.isPlaying,
  playbackRateIdx: lectureContent.playbackRateIdx
})

const mapDispatch = (dispatch: Dispatch) => ({
  onProgressChange: state => dispatch.lectureContent.updateProgress(state)
})

export default connect(
  mapState,
  mapDispatch
)(Content)



// WEBPACK FOOTER //
// ./src/components/Material/Content.tsx